import _regeneratorRuntime from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
// --- Caching
import { Directory, Encoding } from '@capacitor/filesystem';
//import { Filesystem } from '@capacitor/filesystem' // => Doesn't work with blob in native
// Workaround: Use Web-Implementation of plugin
import { FilesystemWeb } from '@capacitor/filesystem/dist/esm/web.js';
var Filesystem = new FilesystemWeb();
// ---
import axios from 'axios';
var FileHelper = /*#__PURE__*/function () {
  function FileHelper(cachedir) {
    _classCallCheck(this, FileHelper);
    this.cachedir = cachedir;
    // -- Dev: Multiple screens in iframes on same window (required to create teaser video)
    var separator = this.cachedir.startsWith('/') ? '' : '/';
    var urlParams = new URLSearchParams(window.location.search);
    if ((process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'staging') && urlParams.get('id')) this.cachedir += separator + urlParams.get('id');
    // ---
  }
  _createClass(FileHelper, [{
    key: "isCachingAvailable",
    value: function isCachingAvailable() {
      var _this = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
          var blob, contents;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                blob = new Blob([1, 2, 3, 4, 5]);
                _context.next = 4;
                return _this.writeFile('test', blob);
              case 4:
                _context.prev = 4;
                _context.next = 7;
                return Filesystem.readFile({
                  path: _this.cachedir + '/test',
                  directory: Directory.Cache,
                  encoding: Encoding.UTF8
                });
              case 7:
                contents = _context.sent;
                if (contents.data.size == blob.size) {
                  resolve();
                } else {
                  reject();
                }
                _context.next = 14;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                reject(_context.t0);
              case 14:
                _context.next = 19;
                break;
              case 16:
                _context.prev = 16;
                _context.t1 = _context["catch"](0);
                reject(_context.t1);
              case 19:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 16], [4, 11]]);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "clearCache",
    value: function () {
      var _clearCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              console.log("Clearing cache");
              _context2.next = 3;
              return Filesystem.rmdir({
                path: this.cachedir,
                directory: Directory.Cache,
                recursive: true
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function clearCache() {
        return _clearCache.apply(this, arguments);
      }
      return clearCache;
    }()
  }, {
    key: "getLocalFile",
    value: function getLocalFile(filename) {
      var url_index = filename.indexOf("://");
      if (url_index > -1) {
        var url = new URL(filename);
        filename = url.pathname;
      }
      var index_of_file = filename.lastIndexOf('/');
      var separator = filename.startsWith('/') ? '' : '/';
      if (filename.startsWith(this.cachedir + separator)) filename = filename.substring(this.cachedir + separator);
      var fullpath = this.cachedir + separator + filename;
      return {
        fullpath: fullpath,
        path: this.cachedir + separator + filename.substring(0, index_of_file + 1),
        filename: filename.substring(index_of_file + 1)
      };
    }
  }, {
    key: "deleteFile",
    value: function deleteFile(filename) {
      var local_file = this.getLocalFile(filename);
      console.log(local_file.fullpath + ' - Deleting file');
      return Filesystem.deleteFile({
        path: local_file.fullpath,
        directory: Directory.Cache
      });
    }

    /**
     * Checks whether file exists in local cache or not
     * 
     * @param {*} url 
     * @returns 
     */
  }, {
    key: "exists",
    value: function () {
      var _exists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(filename) {
        var local_file;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              local_file = this.getLocalFile(filename);
              _context3.prev = 1;
              _context3.next = 4;
              return Filesystem.readFile({
                path: local_file.fullpath,
                directory: Directory.Cache,
                encoding: Encoding.UTF8
              });
            case 4:
              return _context3.abrupt("return", true);
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);
              return _context3.abrupt("return", false);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 7]]);
      }));
      function exists(_x3) {
        return _exists.apply(this, arguments);
      }
      return exists;
    }()
  }, {
    key: "readJSONFile",
    value: function () {
      var _readJSONFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(filename) {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve, reject) {
                  var result, reader;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.prev = 0;
                        _context4.next = 3;
                        return _this2.readFile(filename);
                      case 3:
                        result = _context4.sent;
                        reader = new FileReader();
                        reader.addEventListener("loadend", function () {
                          if (reader.result) {
                            resolve(JSON.parse(reader.result));
                          } else reject(e);
                        });
                        reader.readAsText(result);
                        _context4.next = 12;
                        break;
                      case 9:
                        _context4.prev = 9;
                        _context4.t0 = _context4["catch"](0);
                        reject(_context4.t0);
                      case 12:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4, null, [[0, 9]]);
                }));
                return function (_x5, _x6) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function readJSONFile(_x4) {
        return _readJSONFile.apply(this, arguments);
      }
      return readJSONFile;
    }()
  }, {
    key: "readFile",
    value: function () {
      var _readFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(filename) {
        var local_file, contents;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              local_file = this.getLocalFile(filename);
              _context6.next = 3;
              return Filesystem.readFile({
                path: local_file.fullpath,
                directory: Directory.Cache,
                encoding: Encoding.UTF8
              });
            case 3:
              contents = _context6.sent;
              return _context6.abrupt("return", contents.data);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function readFile(_x7) {
        return _readFile.apply(this, arguments);
      }
      return readFile;
    }()
  }, {
    key: "writeFile",
    value: function () {
      var _writeFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(filename, data) {
        var content_type,
          local_file,
          blob,
          _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              content_type = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : undefined;
              local_file = this.getLocalFile(filename);
              _context7.prev = 2;
              _context7.next = 5;
              return Filesystem.mkdir({
                path: local_file.path,
                directory: Directory.Cache,
                recursive: true
              });
            case 5:
              _context7.next = 9;
              break;
            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7["catch"](2);
            case 9:
              blob = data instanceof Blob ? data : new Blob([data], {
                type: content_type
              });
              _context7.prev = 10;
              _context7.next = 13;
              return Filesystem.writeFile({
                path: local_file.fullpath,
                data: blob,
                directory: Directory.Cache,
                encoding: Encoding.UTF8
              });
            case 13:
              _context7.next = 18;
              break;
            case 15:
              _context7.prev = 15;
              _context7.t1 = _context7["catch"](10);
              console.log(filename + ' - Error caching file => ' + _context7.t1);
            case 18:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[2, 7], [10, 15]]);
      }));
      function writeFile(_x8, _x9) {
        return _writeFile.apply(this, arguments);
      }
      return writeFile;
    }()
    /**
     * Will download the file from URL and cache it
     * 
     * @param {*} url 
     * @returns 
     */
  }, {
    key: "downloadFile",
    value: function downloadFile(url) {
      var _this3 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(resolve, reject) {
          var local_file;
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                local_file = _this3.getLocalFile(url);
                console.log(local_file.fullpath + ' - Downloading file');

                // axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                axios({
                  url: url,
                  method: 'GET',
                  responseType: 'blob'
                }).then( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(response) {
                    var blob;
                    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                      while (1) switch (_context8.prev = _context8.next) {
                        case 0:
                          blob = new Blob([response.data], {
                            type: response.headers['content-type']
                          });
                          _context8.prev = 1;
                          _context8.next = 4;
                          return _this3.deleteFile(url);
                        case 4:
                          _context8.next = 8;
                          break;
                        case 6:
                          _context8.prev = 6;
                          _context8.t0 = _context8["catch"](1);
                        case 8:
                          _context8.prev = 8;
                          _context8.next = 11;
                          return _this3.writeFile(url, response.data, response.headers['content-type']);
                        case 11:
                          _context8.next = 16;
                          break;
                        case 13:
                          _context8.prev = 13;
                          _context8.t1 = _context8["catch"](8);
                          console.log(local_file.fullpath + ' - Error caching file => ' + _context8.t1);
                        case 16:
                          resolve({
                            file: blob,
                            cached: false
                          });
                        case 17:
                        case "end":
                          return _context8.stop();
                      }
                    }, _callee8, null, [[1, 6], [8, 13]]);
                  }));
                  return function (_x12) {
                    return _ref4.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  // console.log(err)
                  _this3.downloadChunkedFile(url).then(function (result) {
                    resolve(result);
                  }).catch(function (err2) {
                    // console.log(err2)
                    reject(err2);
                  });
                });
              case 3:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        return function (_x10, _x11) {
          return _ref3.apply(this, arguments);
        };
      }());
    }

    /**
     * Will download the file from URL in chunks and cache it
     * 
     * @param {*} url 
     * @returns 
     */
  }, {
    key: "downloadChunkedFile",
    value: function downloadChunkedFile(url) {
      var _this4 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!options.chunk_size) options.chunk_size = 10 * 100 * 1024;
      return new Promise( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(resolve, reject) {
          var local_file, content_type, file_size, byte_index, chunks, content, offset_index, from, to, response, content_range, response_head, mergedArray, blob;
          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                local_file = _this4.getLocalFile(url);
                console.log(local_file.fullpath + ' - Downloading chunked file');
                _context10.prev = 2;
                file_size = undefined;
                byte_index = 0;
                chunks = [];
                content = [];
                offset_index = 0;
              case 8:
                if (!(file_size == undefined || file_size > byte_index)) {
                  _context10.next = 39;
                  break;
                }
                from = byte_index;
                to = byte_index + options.chunk_size - 1;
                if (options.offsets) to = offset_index < options.offsets.length ? options.offsets[offset_index++] - 1 : file_size;
                if (to > file_size) to = file_size;
                _context10.next = 15;
                return axios({
                  url: url,
                  method: 'GET',
                  responseType: 'arraybuffer',
                  headers: {
                    range: "bytes=".concat(from, "-").concat(to)
                  }
                });
              case 15:
                response = _context10.sent;
                //byte_index = to + 1
                content_type = response.headers['content-type'];
                //file_size = response.headers['content-length']
                if (!(content_type && response.headers['content-range'])) {
                  _context10.next = 22;
                  break;
                }
                // Read complete file size from content-range
                content_range = response.headers['content-range'];
                file_size = parseInt(content_range.split('/')[1]);
                _context10.next = 27;
                break;
              case 22:
                _context10.next = 24;
                return axios({
                  url: url,
                  method: 'HEAD'
                });
              case 24:
                response_head = _context10.sent;
                content_type = response_head.headers['content-type'];
                file_size = response_head.headers['content-length'];
              case 27:
                chunks = new Uint8Array(response.data);
                //--- content.push(...chunks)   // => max stack size exceeded
                mergedArray = new Uint8Array(content.length + chunks.length);
                mergedArray.set(content);
                mergedArray.set(chunks, content.length);
                content = mergedArray;
                // ---
                if (!options.onChunks) {
                  _context10.next = 36;
                  break;
                }
                if (!options.onChunks(chunks, content_type)) {
                  _context10.next = 36;
                  break;
                }
                // if onChunks returns true we'll break the loop (e.g. destroyed or paused was called)
                reject('Partial download cancelled');
                return _context10.abrupt("return");
              case 36:
                // console.log(`${from} - ${to} => ${response.data.byteLength}`)
                byte_index = from + response.data.byteLength;
                _context10.next = 8;
                break;
              case 39:
                // alert(content.length + '/' + file_size)
                blob = new Blob([content], {
                  type: content_type
                });
                _context10.prev = 40;
                _context10.next = 43;
                return _this4.deleteFile(url);
              case 43:
                _context10.next = 47;
                break;
              case 45:
                _context10.prev = 45;
                _context10.t0 = _context10["catch"](40);
              case 47:
                _context10.prev = 47;
                _context10.next = 50;
                return _this4.writeFile(url, content, content_type);
              case 50:
                _context10.next = 55;
                break;
              case 52:
                _context10.prev = 52;
                _context10.t1 = _context10["catch"](47);
                console.log(local_file.fullpath + ' - Error caching file => ' + _context10.t1);
              case 55:
                resolve({
                  file: blob,
                  cached: false
                });
                _context10.next = 61;
                break;
              case 58:
                _context10.prev = 58;
                _context10.t2 = _context10["catch"](2);
                reject(_context10.t2);
              case 61:
              case "end":
                return _context10.stop();
            }
          }, _callee10, null, [[2, 58], [40, 45], [47, 52]]);
        }));
        return function (_x13, _x14) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "parseDataURL",
    value: function parseDataURL(url) {
      var rBase64Type = /data:(.*);(charset=([^,]*),)?(base64,)?(.*)/;
      var match = url.match(rBase64Type);
      return match;
    }

    /**
     * Will check if the file exists in cache and use the cached file if so.
     * Otherwise the file will be downloaded and cached
     * 
     * @param {*} url 
     * @returns 
     */
  }, {
    key: "getFile",
    value: function getFile(url) {
      var _this5 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new Promise( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(resolve, reject) {
          var match, mimeString, encoding, base64, raw, blob, rawLength, uInt8Array, i, local_file, contents;
          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                // -- Check if url is dataURL
                match = _this5.parseDataURL(url);
                if (!match) {
                  _context11.next = 11;
                  break;
                }
                mimeString = match[1];
                encoding = match[3];
                base64 = match[4];
                raw = match[5];
                if (encoding) mimeString += ";charset=" + encoding;
                raw = base64 ? atob(raw) : decodeURIComponent(raw);
                if (mimeString.startsWith('text')) {
                  blob = new Blob([raw], {
                    type: mimeString
                  });
                } else {
                  rawLength = raw.length;
                  uInt8Array = new Uint8Array(rawLength); // eslint-disable-line
                  for (i = 0; i < rawLength; i += 1) {
                    uInt8Array[i] = raw.charCodeAt(i);
                  }
                  blob = new Blob([uInt8Array], {
                    type: mimeString
                  });
                }
                resolve({
                  file: blob,
                  cached: false
                });
                return _context11.abrupt("return");
              case 11:
                // --
                local_file = _this5.getLocalFile(url);
                _context11.prev = 12;
                _context11.next = 15;
                return Filesystem.readFile({
                  path: local_file.fullpath,
                  directory: Directory.Cache,
                  encoding: Encoding.UTF8
                });
              case 15:
                contents = _context11.sent;
                if (!options.force_cached) {
                  _context11.next = 21;
                  break;
                }
                if (!(contents && contents.data)) {
                  _context11.next = 21;
                  break;
                }
                console.log(local_file.fullpath + ' - Using cached file as offline');
                resolve({
                  file: contents.data,
                  cached: true
                });
                return _context11.abrupt("return");
              case 21:
                // Check if file has changed since it was cached
                axios({
                  url: url,
                  method: 'HEAD',
                  timeout: 3000,
                  responseType: 'blob'
                }).then(function (response) {
                  if (response.headers['content-type'].startsWith("text/html")) {
                    // No caching required => show URL in iFrame
                    resolve({
                      file: new Blob([response.data], {
                        type: response.headers['content-type']
                      }),
                      cached: false
                    });
                  } else {
                    if (!contents.data.type) contents.data.type = response.headers['content-type'];
                    // Can't use response.headers['last-modified'] because can't read last modified date from blob => check file size
                    if (contents.data.size == response.headers['content-length'] && contents.data.type == response.headers['content-type']) {
                      // Used cache file
                      console.log(local_file.fullpath + ' - Using cached file');
                      resolve({
                        file: contents.data,
                        cached: true
                      });
                    } else {
                      // File was modified
                      if (contents.data.size != response.headers['content-length']) console.log(local_file.fullpath + " - Cached file's size differs from online file (Local: ".concat(contents.data.size, " | Remote: ").concat(response.headers['content-length'], ")"));else if (contents.data.type != response.headers['content-type']) console.log(local_file.fullpath + " - Content type has changed (Local: ".concat(contents.data.type, " | Remote: ").concat(response.headers['content-type'], ")"));
                      _this5.downloadFile(url).then(function (r) {
                        resolve(r);
                      }).catch(function (err) {
                        if (contents && contents.data) {
                          console.log(local_file.fullpath + ' - Using cached file due to error => ' + err);
                          resolve({
                            file: contents.data,
                            cached: true
                          });
                        } else reject(err);
                      });
                    }
                  }
                }).catch(function (err) {
                  if (contents && contents.data) {
                    console.log(local_file.fullpath + ' - Using cached file due to error => ' + err);
                    resolve({
                      file: contents.data,
                      cached: true
                    });
                  } else reject(err);
                });
                _context11.next = 28;
                break;
              case 24:
                _context11.prev = 24;
                _context11.t0 = _context11["catch"](12);
                console.log(local_file.fullpath + ' - ' + _context11.t0);
                // File not exists => Download and create cache file
                _this5.downloadFile(url).then(function (r) {
                  resolve(r);
                }).catch(function (err) {
                  reject(err);
                });
              case 28:
              case "end":
                return _context11.stop();
            }
          }, _callee11, null, [[12, 24]]);
        }));
        return function (_x15, _x16) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }]);
  return FileHelper;
}();
export default FileHelper;